import type { LucideIcon } from 'lucide-react'
import {
  Activity,
  Archive,
  BookOpen,
  CalendarClock,
  CalendarCog,
  CalendarOff,
  CalendarRange,
  ChartColumn,
  ClipboardCheck,
  ClipboardList,
  ClipboardPen,
  Clock,
  FileDown,
  FileSpreadsheet,
  FileText,
  FileUser,
  FolderDown,
  Gauge,
  GraduationCap,
  Hourglass,
  IdCard,
  Landmark,
  LayoutDashboard,
  ListChecks,
  Map,
  MessagesSquare,
  Route,
  RouteOff,
  Settings,
  Timer,
  TriangleAlert,
  Truck,
  Users,
} from 'lucide-react'

/** One icon per module/page, shared by the sidebar and pages that link to it. */
export const MODULE_ICONS = {
  dashboard: LayoutDashboard,
  users: Users,
  userDocuments: FileUser,
  forum: MessagesSquare,
  workTimeAndSalary: Clock,
  confirmHours: ClipboardCheck,
  drivingData: Truck,
  issues: TriangleAlert,
  infringements: Timer,
  timeEntries: Clock,
  absences: CalendarOff,
  vehicleFleet: Truck,
  vehicleDocuments: FileText,
  vehicleExpirations: CalendarClock,
  vehicleServices: CalendarCog,
  fleetManagement: Map,
  driverPlanner: CalendarRange,
  remainingDrivingTime: Hourglass,
  infringementAnalytics: ChartColumn,
  driverGrade: Gauge,
  fileArchive: Archive,
  activitiesStatus: Activity,
  drivingInOut: RouteOff,
  drivingWithoutCard: IdCard,
  form: ClipboardList,
  formCreator: ClipboardPen,
  handbook: BookOpen,
  checklists: ListChecks,
  routePlanner: Route,
  exports: FileDown,
  userExports: FolderDown,
  salaryBases: FileSpreadsheet,
  companySettings: Settings,
  learning: GraduationCap,
  arbeidstilsynet: Landmark,
} satisfies Record<string, LucideIcon>
